import { twMerge } from 'tailwind-merge';
import type { DecoratedTask } from '@witmetrics/utils';
import {
  useDateFormatPreference,
  useTimeFormatPreference,
} from '@witmetrics/data-store';
import { classes, getDueDisplay } from './utils';

export type DueDateProps = {
  onlyTime?: boolean;
  task: DecoratedTask;
};

export default function DueDate({ onlyTime, task }: DueDateProps) {
  const dateFormat = useDateFormatPreference();
  const timeFormat = useTimeFormatPreference();

  const { label, textClass, dotClass } = getDueDisplay(task, {
    onlyTime,
    dateFormat,
    timeFormat,
  });

  return (
    <div className={classes.wrapper}>
      {dotClass && <span className={twMerge(classes.dot, dotClass)} />}
      <div className={twMerge(classes.label, textClass)}>{label}</div>
    </div>
  );
}
